module.exports = __webpack_public_path__ + "assets/img/15.690aa859.png";